import { z } from "zod";

export const fileUploadRequestSchema = z.object({
  filename: z.string().min(1, "Filename is required"),
  mime_type: z.string().min(1, "MIME type is required"),
  source_module: z.enum(["AVATAR", "FILE", "COMPANY_LOGO", "TEMPERATURE", "FEEDING", "CAGE_TRIAL_HARVEST", "PL_TRIAL_HARVEST"]),
  size_bytes: z.number().positive("File size must be positive"),
});

export const fileUploadResponseSchema = z.object({
  response_schema: z.object({
    response_code: z.string(),
    response_message: z.string(),
  }),
  response_output: z.object({
    detail: z.object({
      file_id: z.number(),
      upload_url: z.string().url(),
      object_key: z.string(),
    }),
  }),
});

export const fileUploadProgressSchema = z.object({
  loaded: z.number(),
  total: z.number(),
  percentage: z.number().min(0).max(100),
});

export const fileUploadInfoSchema = z.object({
  file: z.instanceof(File),
  file_id: z.number().optional(),
  upload_url: z.string().optional(),
  object_key: z.string().optional(),
  progress: fileUploadProgressSchema.optional(),
  status: z.enum(["pending", "uploading", "success", "error"]),
  error: z.string().optional(),
});

export type FileUploadRequest = z.infer<typeof fileUploadRequestSchema>;
export type FileUploadResponse = z.infer<typeof fileUploadResponseSchema>;
export type FileUploadProgress = z.infer<typeof fileUploadProgressSchema>;
export type FileUploadInfo = z.infer<typeof fileUploadInfoSchema>;

export const fileDownloadResponseSchema = z.object({
  response_schema: z.object({
    response_code: z.string(),
    response_message: z.string(),
  }),
  response_output: z.object({
    detail: z.object({
      file_id: z.number(),
      file_name: z.string(),
      mime_type: z.string(),
      download_url: z.string(),
    }),
  }),
});

export type FileDownloadResponse = z.infer<typeof fileDownloadResponseSchema>;